<template>
  <div class="container-fluid">
    <loading v-if="loadingRender"></loading>
    <!-- <loading v-if="loadingRender"></loading>  -->
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-8 mt-md-5 p-md-5">
        <net-pa-card>
          <template slot="header">
            <b style="font-size: 12px !important" class="text-right">
              <i class="fas fa-cloud-download-alt ml-2"></i> سامانه لینک پرداخت
              <a @click="QrCode = !QrCode">
                <u v-if="!QrCode" class="text-warning"> (دریافت QRCODE)</u>
                <u v-if="QrCode" class="text-warning"> (بازگشت)</u>
              </a>
            </b>
          </template>
          <template slot="content">
            <div v-show="!QrCode" class="container">
              <div class="row">
                <div class="col-12 text-center">
                  <b style="font-size: 15px !important">{{ $session.get('NameSandogh') }}</b>
                </div>
                <hr />
                <div class="col-12">
                  <form id="div1" class="text-center w-100">
                    <div class="row">
                      <div class="col-md-5 col-12">
                        <div class="border-bottom border-warning pb-2">
                          <b style="font-size: 13px !important" class="text-dark">اطلاعات حساب</b>
                        </div>
                        <div>
                          <!-- <div class="form-check text-right mt-3" v-if="!IsQuery">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked @click="getDepositType(1)" />
                            <label class="form-check-label mx-4" for="flexRadioDefault1"> واریز با شناسه واریز حساب | تسهیلات </label>
                          </div> -->

                          <div v-if="!IsQuery" class="mt-2 row text-center">
                            <div class="col-9">
                              <input autocomplete="off" class="form-control text-center" id="Shenase" type="number" placeholder="شناسه واریز" v-model="Shenase" v-mask="'####################'" />
                            </div>
                            <div class="col-3 pr-0">
                              <button type="button" @click="CheckupShenase()" class="btn btn-outline-dark rounded" style="font-size: 14px !important" dir="ltr">بررسی</button>
                            </div>
                          </div>

                          <div class="mt-2 row text-center">
                            <div v-if="Result != null" class="col-12 mb-2 font-weight-bold">
                              <span class="text-secondary"> مشخصات :</span>
                              <span class="text-dark mr-2">{{ Result != null ? Result.nameFamily : '' }}</span>
                              <span class="mr-2">_</span>
                              <span class="text-dark mr-2" dir="ltr">{{ Result != null ? Result.desNoe : '' }}</span>
                              <span v-if="Result.tblSarfaslTypeId == 1" class="mr-2">_ سررسید قسط </span>
                              <span class="text-danger mr-2" dir="ltr">{{ Result != null ? Result.minTarGhestBedehkar : '' }}</span>
                            </div>
                            <div class="col-12">
                              <div class="row">
                                <div class="col-md-12 col-8">
                                  <input class="form-control text-center 3ragham" id="Mab" :disabled="FixVariz" v-model="Mablagh" dir="ltr" type="number" placeholder="مبلغ واریزی" style="font-size: 15px !important" />
                                  <!-- <input class="form-control text-center 3ragham" id="Mab" :disabled="FixVariz" v-model="Mablagh" dir="rtl" @keyup="$PutCommatoInput()" @keypress="$ValidNumber($event, 11)" type="text" placeholder="مبلغ واریزی" style="font-size: 18px !important" /> -->
                                </div>
                                <div class="col-md-12 col-4 pt-2 px-0">
                                  <span class="text-danger h6"> {{ $Comma3ragham(Mablagh) }} </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 mt-2">
                              <span class=" "> {{ ToPersian(Mablagh) }} ريال </span>
                            </div>
                          </div>
                        </div>
                        <div class="border-bottom border-warning pb-2 mt-2">
                          <b style="font-size: 13px !important" class="text-dark">اطلاعات واریز کننده</b>
                        </div>
                        <div>
                          <div class="mt-2 row text-center">
                            <div class="col-12">
                              <input class="form-control text-center required" type="text" placeholder="نام و نام خانوادگی" v-model="NameFamily" :disabled="IsLinkPayCustom" />
                            </div>
                            <div class="col-12 mt-2 mb-3">
                              <input class="form-control text-center required" dir="ltr" type="number" @keypress="$ValidNumber($event, 11)" placeholder="شماره تلفن" v-model="Mobile" :disabled="IsLinkPayCustom" />
                            </div>
                            <div class="col-12 mt-2">
                              <textarea class="form-control text-center" type="text" placeholder="توضیحات" maxlength="300" rows="2" v-model="Description" :disabled="IsLinkPayCustom"></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="border-bottom border-warning pb-2 mt-3">
                          <!-- <b style="font-size: 13px !important" class="text-dark">کد کپچا در تصویر را وارد کنید</b> -->
                        </div>
                        <div class="mt-2">
                          <div class="captcha-box">
                            <canvas ref="canvas" class="d-inline" :width="width" :height="height"></canvas>

                            <div class="actions">
                              <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                  <button title="ایجاد کد کپـچای جدید" class="btn btn-outline-danger rounded-right" type="button" @click.prevent="generateCaptcha"><i class="fas fa-sync" style="font-size: 18px;"></i></button>
                                </div>
                                <input type="number" class="form-control text-center rounded-left" v-model="userInput" placeholder="کد در تصویر را وارد کنید"  aria-label="" aria-describedby="basic-addon1" />
                              </div>
                            </div>

                            <p v-if="result">{{ result }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-7 col-12">
                        <payment @GatewayCode="Get_GatewayCode" @FixVarizGhestHasJarime="FixVarizGhestHasJarime" @FixVarizGhest="FixVarizGhest" :wwwtblShobeid="wwwtblShobeid" v-if="wwwtblShobeid != null">
                          <template v-slot:ContentButtonPayment>
                            <button id="BtnPayment" class="btn w-50" :class="Result == null || Number(Mablagh) < 10000 ? 'btn-secondary' : 'btn-success'" :disabled="Result == null || Number(Mablagh) < 10000" @click.prevent="Payment">
                              واریز
                              {{ $Comma3ragham(Mablagh) }} ريال
                            </button>
                            <div id="AletSumMab" class="alert alert-info w-100 font-weight-bold d-none">تسهیلات انتخابی شما تسویه شده ،برای اطمینان بیشتر با {{ $session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق' }} /شعبه تماس بگیرید</div>
                          </template>
                        </payment>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div v-show="QrCode" class="container text-center">
              <div id="qrcode">
                <h4 style="color: #fff !important">{{ Result != null ? Result.nameFamily : '' }}</h4>
                <qrcode-vue :value="value" :size="size" :render-as="'svg'" level="H" />
                <a style="color: #fff !important" :href="value">{{ value }}</a>
              </div>
              <button class="btn btn-primary" @click="printQr"><i class="fas fa-print"></i> پرینت</button>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-md-2"></div>
    </div>
  </div>
</template>
<script>
import Payment from '../CmpNetPa/Payment.vue'
import Loading from '../Tools/NetPa/Loading.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import QrcodeVue from 'qrcode.vue'
import html2pdf from 'html2pdf.js'
import Num2persian from 'num2persian'

// import loading from '../Tools/NetPa/Loading.vue'
// import VueRecaptchaEh from "vue-recaptcha-eh";
export default {
  components: {
    Payment,
    NetPaCard,
    Loading,
    QrcodeVue,
  },
  data() {
    return {
      captchaCode: '',
      userInput: '',
      result: '',
      width: 150,
      height: 50,

      codeMeli: '',
      QrCode: false,
      value: window.location.href,
      size: 300,
      appsettings: {},
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByShenas',
        Token: '',
      },
      Resultcmb: -1,
      ShenaseOzv: null,
      ListModel: null,
      IsLoad: false,
      DepositType: 1,
      Shenase: '',
      LinkId: '',
      VCode: '',
      Mablagh: '',
      NameFamily: '',
      Mobile: '',
      Description: '',
      Result: null,
      GatewayCode: null,
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByShenaseVariz',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosRowVCode: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByVC',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosRowGetShenase: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/GetShenaseVariz',
        Token: this.$session.get('TokenNetPa'),
      },
      FixVariz: false,
      loadingRender: false,
      MabFormulaJarime: 0,
      CheckUpMablagh: null,
      IsQuery: false,
      IsLinkPay: false,
      IsLinkPayCustom: false,
      wwwtblShobeid: null,
      appsettings: {},
    }
  },
  methods: {
    ToPersian(number) {
      return Num2persian(number)
    },
    gettblCustomer() {
      this.loading = true
      var settings = {
        method: 'Post',
        url: this.appsettings.NetPaApi + 'Setting',
        headers: {},
        data: null,
      }
      var axios = require('axios')
      //   console.log('settings',settings);
      axios(settings).then((result) => {
        this.$PostData({
          ArryfildValue: {},
          Action: 'GetTblCustomer',
          method: 'GET',
          Token: '',
        })
          .then((data) => {
            // console.log('dataaa',data);
            this.$store.state.NameSandogh = data.name
            this.$session.set('NameSandogh', data.name)
            this.$session.set('CustCode', data.custCode)
            document.title = ' خدمات الکترونیکی ' + data.name
            this.loading = false
            this.CheckupLinkPay()
          })
          .catch(function (error) {
            console.log(error)
          })
      })
    },
    // getDepositType(val) {
    //   this.DepositType = val
    //   this.Result = null
    //   // if(val==3){

    //   // }
    // },

    CheckupShenase() {
      if (this.Shenase != '') {
        this.loadingRender = true
        this.VCode = ''
        const formData = new FormData()
        formData.append('ShenaseVariz', this.Shenase)
        this.DataAxiosRow.ArryfildValue = formData

        this.$PostFormData(this.DataAxiosRow).then((data) => {
          if (data.state == 'Success') {
            this.$session.set('likpay', window.location.href)
            this.wwwtblShobeid = data.result.wwwtblShobeid
            this.Result = data.result
            if (data.result.tblSarfaslTypeId != 1) {
              this.FixVariz = false
            }
            if (this.$route.query.IsVgate != undefined) {
              this.$session.set('TokenVgate', true)
            }
            if (data.result.mande + data.result.wwwJarime - data.result.sumMabTaeedNaShode <= 0 && data.result.tblSarfaslTypeId == 1) {
              document.getElementById('Mab').classList.add('d-none')
              document.getElementById('BtnPayment').classList.add('d-none')

              document.getElementById('AletSumMab').classList.remove('d-none')
            } else {
              document.getElementById('Mab').classList.remove('d-none')
              // document.getElementById('BtnPayment').classList.remove('d-none')

              // document.getElementById('AletSumMab').classList.add('d-none')
            }

            if (data.result.mablaghGhestVam > 0) {
              this.Mablagh = data.result.sumGhabelPar
              // this.Mablagh = this.$Comma3ragham(data.result.sumGhabelPar)
              this.CheckUpMablagh = data.result.sumGhabelPar
            } else {
              this.Mablagh = ''
            }

            if (this.LinkId != '' && this.LinkId > 0) {
              this.CheckLinkId(this.LinkId)
            }

            this.loadingRender = false
          } else {
            if (this.$route.query.sh) {
              if (Number(this.$route.query.sh) > 0 && this.$route.query.sh != null) {
                this.$mySweetDefaultTost('خطا', 'شناسه واریز موجود در لینک صحیح نمیباشد.', 'error', 5000)
                this.$router.push({ name: 'LoginPage' })
              }
            } else this.$mySweetDefaultTost('خطا', 'شناسه وارد شده صحیح نمی باشد .', 'error', 2500)
            this.Result = null
            this.loadingRender = false
          }
        })
      } else {
        this.$mySweetDefault('خطا', 'شناسه واریز خالی می باشد ', 'error', 2500)
        this.Result = null
      }
    },
    Payment() {
      if (this.$ValidForm('div1')) {
        if (this.Result.tblSarfaslTypeId != 1) {
          this.SendPayment()
        } else {
          if (this.Result.sumGhabelPar || this.Result.sumGhabelPar != null) {
            if (Number(this.Mablagh) > this.Result.mande + this.Result.wwwJarime - this.Result.sumMabTaeedNaShode) {
              this.$mySweetDefault('هشدار', 'مبلغ پرداختی نمی تواند بیشتر از مانده تسهیلات باشد . ', 'warning', 2500)
            } else {
              this.FormulaJarime()
            }
          } else {
            this.$mySweetDefault('خطا', 'تسهیلات انتخابی شما تسویه شده ،برای اطمینان بیشتر بیشتر با ' + this.$session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق' + ' /شعبه تماس بگیرید', 'error', 2500)
          }
        }
      }
    },
    Get_GatewayCode(val) {
      this.GatewayCode = val
      if (val > 0) {
        this.loadingRender = false
      }
    },
    FixVarizGhest(val) {
      // this.FixVariz = val
      if (this.Result.tblSarfaslTypeId != 1) {
        this.FixVariz = false
      }
    },
    FixVarizGhestHasJarime(val) {
      var jarime = this.Result.wwwJarime
      if (jarime > 0) {
        this.FixVariz = val
      }
    },
    SendPayment() {
      if (this.$route.query.linkId && this.$route.query.linkId > 0) {
        console.log('expirLink')
        this.expirLink()
      }
      let captcha=this.verifyCaptcha()
      if (captcha==false) {
        return
      }
      this.Mablagh = this.Mablagh
      const WwwtblVarizGorohiRiz = []
      WwwtblVarizGorohiRiz.push({
        WwwtblTaahodatId: this.Result.id,
        Mablagh: Number(this.Mablagh),
        SharhRiz: ' واریز | پرداخت  توسط لینک پرداخت ' + this.Description + this.Result.vCode + ' _پرداخت کننده_ ' + this.NameFamily,
        WwwtblAzaId: this.Result.wwwtblAzaId,
        BnpCashDBtblTaahodatId: this.Result.bnpCashDBtblTaahodatId,
        BnpCashDBtblAzaId: this.Result.bnpCashDBtblAzaId,
        MablaghJarime: Math.floor(this.MabFormulaJarime),
        TarixGhest: this.Result.minTarGhestBedehkar,
        IsTaahodatRiz: false,
      })

      this.DataAxios_Variz.ArryfildValue.Mablagh = Number(this.Mablagh)
      this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0
      this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.Sharh = ' واریز | پرداخت  توسط لینک پرداخت ' + ' _پرداخت کننده_ ' + this.NameFamily
      this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get('CustCode'))
      this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538
      this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = Number(this.Result.wwwtblAzaId)
      this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
      this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz
      this.$PostData(this.DataAxios_Variz).then((result) => {
        if (result.status === 'Success') {
          this.$Payment(
            this.GatewayCode + '',
            this.Mablagh + '',
            this.NameFamily,
            'linkpay',
            this.Mobile,
            WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
            this.Shenase + '',
            this.Result.vCode,
            'واریز | پرداخت  توسط لینک پرداخت',
            this.Result.wwwtblAzaId + '',
            this.$session.get('CustCode'),
            this.Result.wwwtblShobeid + '',
            result.idRepoMaster,
            this.Result.codeMeli.trim(),
            this.Result.nameFamily,
            this.Result.mobile,
            this.Result.codeMeli.trim()
          )
        } else {
          this.$mySweetDefaultTost(' ', ' در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید', 'warning', 4000)
          this.DeleteAllItemsCart()
        }
      })
    },
    FormulaJarime() {
      if (Number(this.Mablagh) < Number(this.CheckUpMablagh)) {
        var MablaghJarime = this.Result.wwwJarime == null ? 0 : this.Result.wwwJarime
        if (this.$session.get('CustCode') == 561) {
          this.MabFormulaJarime = (Number(this.Mablagh) / Number(this.CheckUpMablagh)) * MablaghJarime
        } else {
          this.MabFormulaJarime = (Number(this.Mablagh) / (Number(this.CheckUpMablagh) - MablaghJarime)) * MablaghJarime
        }
        this.SendPayment()
      } else {
        this.MabFormulaJarime = this.Result.wwwJarime == null ? 0 : this.Result.wwwJarime
        this.SendPayment()
      }
    },
    CheckupLinkPay() {
      if (this.$route.query.sh) {
        if (this.$route.query.sh != null) {
          if (this.IsLinkPay) {
            this.loadingRender = true
            this.IsQuery = true
            this.Shenase = this.$route.query.sh + ''
            if (this.$route.query.linkId && this.$route.query.linkId > 0) {
              this.LinkId = this.$route.query.linkId
            }
            this.CheckupShenase()
          } else {
            this.$mySweetDefaultTost('خطا', 'سامانه واریز با لینک پرداخت برای شما فعال نگریدیده ، لطفا با مدیریت ' + this.$session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق' + ' هماهنگ کنید', 'error', 8000)
            this.loadingRender = true
          }
        } else {
          this.IsQuery = false
        }
      } else {
        this.IsQuery = false
      }
    },
    printQr() {
      var htmls = document.getElementById('qrcode')
      var htmlObject = document.createElement('div')

      // text-align: center !important; padding-top: 5cm; padding: bottom 5cm
      htmlObject.style.textAlign = 'center'
      htmlObject.style.paddingTop = '5cm'
      htmlObject.style.background = ' url(./Template/NewMenu/img/NetPaImage/LinkPay.png)'
      htmlObject.style.backgroundSize = '100%'
      htmlObject.style.height = '21cm'
      htmlObject.innerHTML = htmls.innerHTML
      html2pdf(htmlObject, {
        jsPDF: { format: 'a5' },
      })
    },
    CheckLinkId() {
      let DataAxios = {
        ArryfildValue: '',
        Method: 'get',
        Action: 'LinkPay',
        Token: this.$session.get('TokenNetPa'),
      }
      DataAxios.ArryfildValue = { Id: 'Get?' + 'linkPayId=' + this.LinkId }
      this.$GetData_Header(DataAxios).then((res) => {
        if (res.status == 'Ok') {
          this.FixVariz = true
          this.IsLinkPayCustom = true
          this.Mablagh = res.data.amount
          this.NameFamily = res.data.name
          this.Mobile = res.data.mobile
          this.Description = res.data.des
        } else {
          this.$mySweetDefaultTost('خطا', 'لینک منقضی شده است ', 'error', 3000)
          this.$router.push({ name: 'LoginPage' })
        }
      })
    },
    expirLink() {
      let DataAxios = {
        ArryfildValue: '',
        Method: 'get',
        Action: 'LinkPay',
        Token: this.$session.get('TokenNetPa'),
      }
      DataAxios.ArryfildValue = { Id: 'GetIsUse?' + 'linkPayId=' + this.LinkId }
      this.$GetData_Header(DataAxios).then((res) => {
        if (res.status == 'Ok') {
        }
      })
    },
    CheckInternetBankVersion() {
      var axios = require('axios')
      var config = {
        method: 'GET',
        url: '/appSettings.json?nocache=123',
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
          'Content-Type': 'application/json',
        },
      }
      axios(config).then((result) => {
        if (this.$store.state.VersionSoftware != result.data.VersionSoftware) {
          // window.location = window.location.href + '?eraseCache=true'
          this.$router.push({ name: 'LoginPage' })
        } else {
          this.appsettings = result.data
          console.log('😂 ~ this.appsettings:', this.appsettings)
          this.$store.state.VersionSoftware = result.data.VersionSoftware
        }
      })

      this.$store.state.loadingRender = false
      var ver = localStorage.getItem('VersionSoftware')

      if (ver == null) {
        localStorage.setItem('VersionSoftware', this.$store.state.VersionSoftware)
      } else {
        var OldVer = localStorage.getItem('VersionSoftware')
        var NewVer = this.$store.state.VersionSoftware
        console.log('😂 ~ NewVer:', NewVer)
        console.log('😂 ~ OldVer:', OldVer)
        if (OldVer != NewVer) {
          localStorage.setItem('VersionSoftware', this.$store.state.VersionSoftware)
          this.$swal({
            title: 'بروزرسانی جدید',
            text: 'نسخه جدید در دسترس میباشد ، لطفا تایید نمایید تا نسخه شما بروزرسانی شود',
            icon: 'success',
            position: 'center',
            confirmButtonText: 'تایید',
            showConfirmButton: true,
            showCancelButton: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload(true)
            }
          })
        }
      }
    },

    generateCaptcha() {
      // const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
      const chars = '0123456789'
      this.captchaCode = Array.from({ length: 5 }, () => chars[Math.floor(Math.random() * chars.length)]).join('')

      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')

      // پاک کردن بوم
      ctx.clearRect(0, 0, this.width, this.height)

      // پس‌زمینه
      ctx.fillStyle = '#f2f2f2'
      ctx.fillRect(0, 0, this.width, this.height)

      // خطوط مزاحم
      for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = this.randomColor()
        ctx.beginPath()
        ctx.moveTo(Math.random() * this.width, Math.random() * this.height)
        ctx.lineTo(Math.random() * this.width, Math.random() * this.height)
        ctx.stroke()
      }

      // نوشتن کپچا
      ctx.font = '26px Arial'
      ctx.fillStyle = '#333'
      ctx.textBaseline = 'middle'
      ctx.textAlign = 'center'
      ctx.fillText(this.captchaCode, this.width / 2, this.height / 2)

      // نویز نقطه‌ای
      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = this.randomColor()
        ctx.fillRect(Math.random() * this.width, Math.random() * this.height, 1.5, 1.5)
      }

      this.userInput = ''
      this.result = ''
    },
    verifyCaptcha() {
      if (this.userInput.toUpperCase() === this.captchaCode) {
        // this.result = '✅ درست وارد شد'
        return true
      } else {
        // this.result = '❌ نادرست است، لطفاً دوباره تلاش کنید'
        this.generateCaptcha();
        this.$mySweetDefault('خطا کپــچا','لطفا کد کپچای  در تصویر را به  درستی وارد کنید','warning',2500)
        return false
      }
    },
    randomColor() {
      const r = Math.floor(Math.random() * 256)
      const g = Math.floor(Math.random() * 256)
      const b = Math.floor(Math.random() * 256)
      return `rgb(${r},${g},${b})`
    },
  },
  // updated() {
  //   if (document.getElementById("SelectNoeVarizi") === document.activeElement) {
  //     if (this.DepositType == 1) {
  //       document.getElementById("Shenase").focus();
  //     }
  //     if (this.DepositType == 2) {
  //       document.getElementById("VCode").focus();
  //     }
  //   }
  // },
  mounted() {
    //console.log(window.location.href);
    if (!this.$route.query.sh) {
      this.$router.push({ name: 'LoginPage' })
    }
    this.CheckInternetBankVersion()
    this.generateCaptcha()

    // if (!this.$session.get('CustCode')) {
    //   console.warn('MOUNTES')
    //   this.$router.push({ name: 'LoginPage' })
    // }
    // console.warn(window.location.href)
  },
  created() {
    var axios = require('axios')
    var config = {
      method: 'GET',
      url: '/appSettings.json?nocache=123',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
      },
    }
    axios(config).then((result) => {
      // console.log(result);
      this.appsettings = result.data
      this.IsLinkPay = result.data.IsLinkPay
      this.gettblCustomer()
    })

    //this.gettblCustomer()
  },
}
</script>
<style scoped>
.captcha-box {
  display: inline;
  flex-direction: column;
  align-items: center;
}
canvas {
  border: 1px solid #ccc;
  margin-bottom: 10px;
}
.actions {
  display: inline;
  gap: 8px;
  align-items: center;
}
input {
  padding: 5px;
}
button {
  padding: 6px 10px;
  cursor: pointer;
}
.border-warning {
  border-bottom: 1px dashed #ff9800 !important;
}

.To {
  background-color: #3a3a4100;
  border: none;
  border-bottom: 2px solid #dca722;
  color: #dca722 !important;
  border-radius: 0px;
  width: 100%;
}
</style>
